import { AGENTS } from './constants';
import { dateText, parse } from './format';
const EMPTY_CHART = { line: '', area: '', bandY: 0, bandH: 0, bandBottom: 0, dots: [], marks: [] };
export function sortMeasurements(measurements) {
    return measurements.slice().sort((a, b) => (a.date === b.date ? a.id - b.id : a.date < b.date ? -1 : 1));
}
/** Eindeutige, aufsteigend sortierte Messtermine (Kalendertage mit mind. einer Messung). */
function distinctDates(measurements) {
    const dates = sortMeasurements(measurements).map(e => e.date);
    return dates.filter((d, i, a) => a.indexOf(d) === i);
}
export function maxPage(measurements) {
    return Math.max(0, distinctDates(measurements).length - 7);
}
/** Fenster von 7 aufeinanderfolgenden Messterminen, `page` Messungen von den neuesten zurück. */
export function pageDates(measurements, page) {
    const all = distinctDates(measurements);
    const mp = Math.max(0, all.length - 7);
    const p = Math.min(page, mp);
    const start = Math.max(0, all.length - 7 - p);
    return { dates: all.slice(start, Math.min(all.length, start + 7)), maxPage: mp, page: p };
}
export function chartFrom(src, key, lo, hi, win, care) {
    const W = 320;
    const H = 104;
    if (!src.length)
        return EMPTY_CHART;
    const vals = src.map(e => e[key]);
    let min = Math.min(lo, ...vals);
    let max = Math.max(hi, ...vals);
    const pad = (max - min) * 0.28 || 0.2;
    min -= pad;
    max += pad;
    const X = (i) => (src.length < 2 ? W / 2 : i * (W / (src.length - 1)));
    const Y = (v) => H - ((v - min) / (max - min)) * H;
    const pts = vals.map((v, i) => ({ x: +X(i).toFixed(1), y: +Y(v).toFixed(1) }));
    let line = `M${pts[0].x} ${pts[0].y}`;
    for (let i = 1; i < pts.length; i++) {
        const a = pts[i - 1];
        const b = pts[i];
        const mx = (a.x + b.x) / 2;
        line += ` C${mx} ${a.y},${mx} ${b.y},${b.x} ${b.y}`;
    }
    const lastIdx = pts.length - 1;
    const lastPt = pts[lastIdx];
    const firstPt = pts[0];
    return {
        line,
        area: `${line} L${lastPt.x} ${H} L${firstPt.x} ${H} Z`,
        bandY: +Y(hi).toFixed(1),
        bandH: +(Y(lo) - Y(hi)).toFixed(1),
        bandBottom: +Y(lo).toFixed(1),
        dots: pts.map((p, i) => ({ x: p.x, y: p.y, r: i === lastIdx ? 5 : 3, label: dateText(src[i].date) })),
        marks: care
            .filter(c => c.type === 'dose' && win.indexOf(c.date) !== -1 && (key === 'ph' ? c.agent !== 'chlor' : c.agent === 'chlor'))
            .map(c => {
            let best = 0;
            let bd = Infinity;
            src.forEach((e, i) => {
                const d = Math.abs(parse(e.date).getTime() - parse(c.date).getTime());
                if (d < bd) {
                    bd = d;
                    best = i;
                }
            });
            const cx = pts[best] ? pts[best].x : 0;
            return { x: Math.max(1, Math.min(319, cx)), fill: c.agent ? AGENTS[c.agent].color : 'var(--dot-note)' };
        })
    };
}
